'use client';

import { forwardRef, useState, type ComponentProps } from 'react';

import { InputAction, TextInput } from '@eliadmin/core/src/components/nt/forms/controls';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

type PasswordInputProps = Omit<ComponentProps<typeof TextInput>, 'type' | 'action'>;

/**
 * Figma „Form / Input“ with the „Zobraziť“ action (221:13176 „Heslo“) for any password field – the
 * same look as the account `PasswordField`, but not bound to a form, so a page can hold more than
 * one (the sign-in form under the reset modal). „Skryť“ hides the value again. Forwards the ref, so
 * `register()` works on it directly.
 */
export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  function PasswordInput(props, ref) {
    const { t } = useTranslations();
    const [visible, setVisible] = useState(false);

    return (
      <TextInput
        ref={ref}
        type={visible ? 'text' : 'password'}
        autoCapitalize="off"
        spellCheck={false}
        action={
          <InputAction onClick={() => setVisible(value => !value)}>
            {visible ? t('text3256') : t('text2076')}
          </InputAction>
        }
        {...props}
      />
    );
  },
);
